//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import {
  CodeApi1,
  CodeApi2,
  CodeApiForm,
  CostumHook,
  CodeApi3,
  CodeApi4
} from './codes';
import alex from '@assets/alex.png';
import jamie from '@assets/jamie.png';

type ApiDocumentsProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const ApiDocuments = ({
  isClosed,
  showImg,
  showMedia
}: ApiDocumentsProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>UNDERSTANDING API'S</h3>
        <span style={{ marginBottom: '25px', fontWeight: '400' }}>
          TECHNICAL DOCUMENTATION / API'S FOR SOFTWARE ENGINEERS
        </span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video
            controlsList="nodownload"
            controls={true}
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={showMedia} type="video/mp4" />
          </video>
        )}

        <h2 className="markTitle" style={{ marginTop: '30px' }}>
          Contents
        </h2>
        <p
          style={{ textAlign: 'left', width: '100%', marginTop: `${pValue}px` }}
        >
          <span style={{ paddingLeft: `${pValue}px` }}>1- Introduction</span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2- How to use an API with React Hooks
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            3- For Jamie (Non-Technical user)
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>4- Survey</span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>5- FAQs</span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>6- Case study</span>
          <br />
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle" style={{ marginBottom: '30px' }}>
          Personas
        </h2>
        <Image
          className={'personaImg'}
          src={alex}
          width={459}
          height={303}
          alt="Persona Alex"
          style={{ marginBottom: '25px' }}
        />
        <Image
          className={'personaImg'}
          src={jamie}
          width={459}
          height={325}
          alt="Persona Alex"
        />
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">1. Introduction</h2>
        <p style={{ textAlign: 'left' }}>
          <b style={{ fontSize: '20px', color: '#000' }}>
            For Alex - Full-Stack Developer
          </b>
          <br />
          <br />
          An API (Application Programming Interface) is a set of rules and
          protocols that allows one software application to interact with
          another. It acts as a bridge between different software systems,
          enabling them to share data and functionalities without needing to
          know the internal workings of each system. See the explanation
          example:
          <br />
          <br />
          <b>Importance of APIs</b>
          <br />
          APIs are crucial in modern software development because they allow
          developers to integrate third-party services, reuse existing code, and
          build complex systems with modular components. For businesses, APIs
          facilitate collaboration, enhance user experience, and open up new
          revenue streams.
          <br />
          <br />
          <b>1-Endpoints:</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>1.1- Definition:</b> An
          endpoint is a specific URL where an API can be accessed by a client.
          It usually represents a resource or a collection of resources.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>1.2- Example:</b>{' '}
          https://api.example.com/users might be an endpoint to retrieve user
          data.
          <br />
          <br />
          <b>2- Methods:</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>2.1- GET:</b> Retrieve data
          from the server.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>2.2- POST:</b> Send data to
          the server to create a new resource.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>2.3- PUT/PATCH:</b> Update
          an existing resource on the server.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>2.4- DELETE:</b> Remove a
          resource from the server.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>2.5- Example:</b> GET
          /users/123 might retrieve the user with ID 123.
          <br />
          <br />
          <b>3- Authentication:</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.1- Types:</b> APIs often
          require authentication to ensure that only authorized users can access
          certain data or functionalities.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.2- API Key:</b> A simple
          token that is passed with each request.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.3- OAuth:</b> A more
          secure method that involves token exchanges.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.4- Example:</b>{' '}
          <code>'Authorization: Bearer token'</code> in the request header.
          <br />
          <br />
          <b>REST vs. SOAP</b>
          <br />
          <br />
          <b>1- REST (Representational State Transfer):</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.1- Lightweight and easier to implement.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.2- Uses standard HTTP methods (GET, POST, etc.).
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.3- Supports multiple data formats, with JSON being the most
            common.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.4- Example: REST APIs are commonly used for web services like
            Twitter, GitHub, etc.
          </span>
          <br />
          <br />
          <b>2- SOAP (Simple Object Access Protocol):</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.1- More rigid and protocol-heavy.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.2- Uses XML exclusively for data exchange.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.3- Provides built-in error handling and security features.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.4- Example: SOAP APIs are often used in enterprise-level
            applications like banking.
          </span>
          <br />
          <br />
          <b>Common Data Formats</b>
          <br />
          <br />
          <b>1- JSON (JavaScript Object Notation):</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.1- Lightweight and easy to parse.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.2- Commonly used in REST APIs.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.3- Example: <code>{'{ "name": "John", "age": 30 }'}</code>
          </span>
          <br />
          <br />
          <b>2- XML (eXtensible Markup Language):</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.1- More verbose than JSON.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.2- Used in SOAP APIs.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.3- Example:{' '}
            <code>{'<user><name>John</name><age>30</age></user>'}</code>
          </span>
          <br />
          <br />
          <b>Error Handling</b>
          <br />
          <br />
          <b>1- Status Codes:</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>1.1- 200 OK:</b> The request
          was successful.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>1.2- 201 Created:</b> A new
          resource was successfully created.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>
            1.3- 400 Bad Request:
          </b>{' '}
          The request was malformed.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>
            1.4- 401 Unauthorized:
          </b>{' '}
          Authentication failed.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>
            1.5- 500 Internal Server Error:
          </b>{' '}
          A generic error on the server.
          <br />
          <br />
          <b>2- Error Messages:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.1- APIs should return meaningful error messages along with status
            codes to help diagnose issues.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.2- Example: <code>{'{"error": "Invalid API key"}'}</code>
          </span>
          <br />
          <br />
          <b>3- API Versioning</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.1- Why Version?:</b> APIs
          evolve over time, and versioning helps manage changes without breaking
          existing client applications.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>3.2- How to Version:</b>
          <br />
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            3.2.1- In URL: https://api.example.com/v1/users
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue + pValue}px` }}>
            3.2.2- In Headers:{' '}
            <code>Accept: application/vnd.example.v1+json</code>
          </span>
          <br />
          <br />
          <b>4- Rate Limiting</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.1- Definition:</b> Rate
          limiting restricts the number of API requests a client can make within
          a certain time frame.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.2- Why?:</b> Prevents
          abuse and ensures fair usage among all users.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.3- Example:</b> A limit of
          1000 requests per hour.
          <br />
          <br />
          <b>4- Best Practices</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.1- Consistency:</b> Use
          consistent naming conventions and HTTP methods.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.2- Documentation:</b>{' '}
          Provide clear and comprehensive documentation.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.3- Security:</b> Always
          secure APIs with proper authentication and encryption.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>4.4- Testing:</b> Implement
          thorough testing to ensure API reliability.
          <br />
          <br />
          <b>Types of APIs</b>
          <br />
          <br />
          <b>1- Web APIs (HTTP APIs):</b>
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>
            1.1- REST (Representational State Transfer):
          </b>{' '}
          The most common type of web API. It uses HTTP methods like GET, POST,
          PUT, DELETE to interact with resources.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>
            1.2- SOAP (Simple Object Access Protocol):
          </b>{' '}
          An older protocol that relies on XML messaging. It is more rigid and
          commonly used in enterprise environments.
          <br />
          <br />
          <b style={{ paddingLeft: `${pValue}px` }}>1.3- GraphQL:</b> A more
          flexible query language for APIs, allowing clients to request exactly
          what they need.
          <br />
          <br />
          <b>2- Library/Framework APIs:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.1- These APIs allow developers to use pre-built functions and
            features provided by libraries or frameworks within their code.
          </span>
          <br />
          <br />
          <b>3- Operating System APIs:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            3.1- These APIs allow applications to interact with the operating
            system, such as file management, process control, and memory
            management.
          </span>
          <br />
          <br />
          <b>4- Hardware APIs:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            4.1- These allow software to interact with hardware devices, like
            cameras, printers, or sensors.
          </span>
          <br />
          <br />
          <br />
          <b style={{ fontSize: '20px', color: '#000' }}>
            For Jamie - Product Manager
          </b>
          <br />
          <br />
          APIs are like bridges between different software programs. Imagine you
          have a to-do list app. To get the latest tasks, the app needs to
          "talk" to a server somewhere. APIs make this possible by providing a
          way for the app to request and receive data from that server.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">2. How to use an API with React Hooks</h2>
        <p style={{ textAlign: 'left' }}>
          I will walk you through using an API in a React application with
          Hooks, covering the essentials like fetching data, handling loading
          states, and managing errors. We'll use axios for making HTTP requests,
          but you can use the native fetch API as well.
          <br />
          <br />
          <b>Alex (Software Engineer)</b>, try to understand all the steps
          explained. Create your test app and do your testing. If you have any
          doubts, fill out the survey on this documentation, and I will give you
          a deeper explanation. The FQAs are also important and will help you to
          clarify some questions you might have.
          <br />
          <br />
          <b>Jamie (Product Manager)</b>, the technical description can be
          confusing or even difficult to follow. I will help you to be inside
          the development world. I'll post examples to make sure you are on the
          same page as Alex and also open a path for you to learn how the APIs
          world flies in developers' hands. Read the FAQs, which will dive you
          into a different knowledge, and provide a good understanding of this
          document.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>Contents</h2>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1- Setting Up the Environment
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2- Creating a React App
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            3- Installing Axios
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            4- Using <code>useEffect</code> and <code>useState</code> for API
            Requests
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            5- Handling Loading and Error States
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            6- Making POST Requests with React Hooks
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            7- Advanced Usage: Custom Hook for API Calls
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            8- Integrating API Data into Your Application
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>9- Conclusion</span>
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>1. Setting Up the Environment</b>
          </h2>
          <br />
          Before we dive into the code, make sure you have Node.js the latest
          version and npm (Node Package Manager) installed on your machine.
          You'll need them to create and manage your React application. If
          "yarn" it is your perference, you can install it via npm: <br />
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          Ensure you have Node.js and npm installed on your machine. These tools
          are necessary for managing your React project and its dependencies.
          <br />
          <code>npm install --global yarn</code>
          <br />
          <br />
          After, Check that Yarn is installed by running:
          <br />
          <code>yarn --version</code>
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          You don't need to set up anything yourself, but it's good to know that
          developers use tools like Node.js and npm to manage the software
          they'll write. These tools help create, run, and manage the different
          pieces of a web application.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>2. Creating a React App</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          To create a new React app, simply use the following command in your
          terminal. I'll use <i>'api-with-hooks'</i> for the name of our app,
          but feel free to choose whatever name you like for yours.
          <br />
          <code>npx create-react-app api-with-hooks</code>
          <br />
          <code>cd api-with-hooks</code>
          <br />
          <br />
          This sets up a new React project in a directory named{' '}
          <i>'api-with-hooks'</i>.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          Developers use a framework called React to build the user interface of
          your app. By running the above commands, they create a new project
          with everything needed to start building.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>3. Installing Axios</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          Next, install axios, a promise-based HTTP client, which simplifies
          making API requests in React:
          <br />
          <code>npm install axios</code>
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          Axios is a tool developers use to make it easier to request data from
          the server. Think of it as a translator that helps your app
          communicate with other services.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>4. Using 'useEffect' and 'useState' for API Requests</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          React's <b>useEffect</b> hook is perfect for making API requests when
          a component mounts. Combined with <b>useState</b>, you can manage the
          data returned from the API and the component's render state.
          <br />
          <br />
          <b>Example: Fetching Data from an API</b>
          <br />
          <br />
          Let’s fetch data from a fictional API endpoint{' '}
          <b>https://api.example.com/tasks</b> and display it in a component.
          <br />
          <br />
          <CodeApi1 />
          <br />
          <br />
          <b>Explanation:</b>
          <br />
          <br />
          1- <code>useState([])</code>: Initializes an empty array to hold the
          tasks.
          <br />
          2- <code>useState(true)</code>: Initializes the loading state as true
          since data fetching is an asynchronous operation.
          <br />
          3- <code>useEffect</code>: Runs once when the component mounts.
          Inside, we define fetchTasks to fetch data from the API.
          <br />
          4- <code>axios.get</code>: Sends a GET request to the API. On success,
          the tasks are stored in the state. On failure, the error is stored.
          <br />
          5- <b>Conditional Rendering</b>: Depending on the state (loading,
          error, or data), the component renders different content.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          In this example, the app is using a function called useEffect to fetch
          data from a server when it first loads. The useState function is used
          to store the tasks we get from the server. The app will show a loading
          message while it’s waiting for the data, and an error message if
          something goes wrong.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>5. Handling Loading and Error States</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          Handling loading and error states is crucial for a good user
          experience. We've already touched on this in the previous example, but
          let's break it down further.
          <br />
          <br />
          <b>Example: Enhancing Loading and Error Handling</b>
          <br />
          <br />
          <CodeApi2 />
          <br />
          <br />
          <b>Key Points:</b>
          <br />
          <br />
          <b>1- Error Handling:</b> Errors are caught and set to the error
          state, then displayed if present.
          <br />
          <b>2- Loading State:</b> A loading message is displayed while the data
          is being fetched.
          <br />
          <b>3- </b>
          <code>finally</code> <b>Block:</b> Ensures that loading is set to
          false whether the request succeeds or fails.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          When the app is fetching data, it shows a "Loading" message to the
          user. If something goes wrong, it displays an error message. This
          helps users know what's happening behind the scenes.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>6. Making POST Requests with React Hooks</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          To send data to the API, such as creating a new task, you can use the
          axios.post method within an event handler.
          <br />
          <br />
          <b>Example: Creating a New Task</b>
          <br />
          <br />
          <CodeApiForm />
          <br />
          <br />
          <b>Explanation:</b>
          <br />
          <br />
          <b>1- Form Handling:</b> The form’s onSubmit event is handled by
          handleSubmit, which prevents the default form submission behavior and
          performs the API request.
          <br />
          <b>2- State Management:</b> The component manages the form input
          (title), loading, and error states.
          <br />
          <b>3- </b>
          <code>axios.post</code>: Sends a POST request with the task data (in
          this case, just the title). On success, the form is cleared; on
          failure, an error message is displayed.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          In this example, when you fill out a form to create a new task, the
          app sends the data to the server. The handleSubmit function manages
          this process. If the task is created successfully, the form clears. If
          there’s an issue, the app will let you know.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>7. Advanced Usage: Custom Hook for API Calls</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          For more complex applications, you can create a custom hook to manage
          API requests. This promotes code reuse and keeps your components
          clean.
          <br />
          <br />
          <b>Example: Creating a Custom Hook</b>
          <br />
          <br />
          <CostumHook />
          <br />
          <b>Usage Example:</b>
          <br />
          <br />
          <CodeApi3 />
          <br />
          <br />
          <b>Explanation:</b>
          <br />
          <br />
          <b>1- </b>
          <code>useApi Hook</code>: This custom hook encapsulates the logic for
          making API requests, handling loading and error states, and returning
          the data.
          <br />
          <b>Reusability:</b> The <code>useApi hook</code> can be reused across
          different components, simplifying your codebase.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          Think of a custom hook as a reusable tool. Developers create these
          tools to make it easier to do repetitive tasks, like fetching data.
          This saves time and reduces errors in the app.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>8. Integrating API Data into Your Application</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          After fetching data, you’ll often want to integrate it into your
          application's UI. Let’s enhance the task list example by adding the
          ability to delete tasks.
          <br />
          <br />
          <b>Example: Deleting a Task</b>
          <br />
          <br />
          <CodeApi4 />
          <br />
          <br />
          <b>Explanation:</b>
          <br />
          <br />
          <b>1- Delete Button:</b> Each task in the list now includes a "Delete"
          button.
          <br />
          <b>2- handleDelete Function:</b> Sends a DELETE request to the API to
          remove a task. Upon success, the task is removed from the UI by
          updating the state.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          This example adds a "Delete" button next to each task. When clicked,
          the app removes the task from both the server and the list you see on
          the screen. This feature is common in apps to allow users to manage
          their content.
          <br />
          <br />
          <br />
          <h2 style={{ color: '#000' }}>
            <b>9. Conclusion</b>
          </h2>
          <br />
          <b>For Alex (Software Engineer):</b>
          <br />
          This guide covered the essentials of using an API in a React
          application with Hooks. You've learned how to fetch data, handle
          different states, send data to an API, and create reusable code with
          custom hooks. These practices help in building efficient, scalable,
          and maintainable applications, including:
          <br />
          <br />
          1- Setting up your environment and installing necessary packages.
          <br />
          2- Fetching data using <code>useEffect</code> and{' '}
          <code>useState</code>.
          <br />
          3- Handling loading and error states.
          <br />
          4- Sending POST requests to create data.
          <br />
          5- Creating a custom hook for reusable API logic.
          <br />
          6- Integrating API data into your application's UI.
          <br />
          <br />
          By following these steps, you can effectively manage API interactions
          in your React applications using hooks, leading to more efficient,
          maintainable, and scalable code.
          <br />
          <br />
          <b>For Jamie (Product Manger - Non-Technical user):</b>
          <br />
          You now have a basic understanding of how APIs interact with a React
          app. While you might not write the code yourself, you can now better
          understand the discussions around API integrations in your projects
          and communicate more effectively with your development team.
          <br />
          <br />
          If you have any questions or concerns, don't hesitate to email me:{' '}
          <a href="mailto:george.martins@jorgedd.com">
            <code>george.martins@jorgedd.com</code>
          </a>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">3. For Jamie (Non-Technical user)</h2>
        <p style={{ textAlign: 'left' }}>
          <b>API in Simple Terms</b>
          <br />
          Imagine an API as a waiter in a restaurant. You (the client) tell the
          waiter what you want from the menu (make a request), and the waiter
          (API) delivers your order to the kitchen (server). The kitchen
          prepares your food (processes the request), and the waiter brings it
          back to you (response). You don't need to know how the kitchen
          operates; you just place your order and receive your meal.
          <br />
          <br />
          <b>Real-World Examples</b>
          <br />
          <br />
          <b>1- Social Media Integration:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            1.1- When you see tweets or Facebook posts on a website, that’s an
            API in action, allowing the website to communicate with Twitter or
            Facebook.
          </span>
          <br />
          <br />
          <b>2- Online Payments:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            2.1- When you pay for something online using PayPal or a credit
            card, APIs are used to process the transaction securely.
          </span>
          <br />
          <br />
          <b>3- Weather Apps:</b>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            3.1- Weather apps fetch the latest data from meteorological servers
            via APIs.
          </span>
          <br />
          <br />
          <b>Why Should You Care About APIs?</b>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>1- Seamless Experiences:</b> APIs enable different apps and
            websites to work together, making your online experience smoother.
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>2- Faster Development:</b> Businesses can build new products
            faster by reusing existing functionalities via APIs.
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>3- Innovation:</b> APIs allow companies to innovate and offer new
            services by leveraging third-party platforms.
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">4. Survey</h2>
        <p style={{ textAlign: 'left' }}>
          We value your feedback and are committed to improving our
          documentation to better serve your needs. Please take a moment to
          answer a few questions:
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>1. How helpful did you find this documentation?</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.1- Very Helpful
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.2- Somewhat Helpful
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.3- Neutral
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.4- Not Very Helpful
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.5- Not Helpful at All
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>
              2. Which sections of the documentation were the most useful?
              (Select all that apply)
            </b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.1- Introduction to APIs
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.2- Setting Up the Environment
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.3- Using React Hooks for API Requests
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.4- Handling Loading and Error States
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.5- Making POST Requests
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.6- Advanced Usage: Custom Hook for API Calls
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.7- Integrating API Data into Your Application
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.8- All of the above
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>
              3. Did the documentation meet your expectations for clarity and
              ease of understanding?
            </b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            3.1- Exceeded Expectations
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            3.2- Met Expectations
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            3.3- Below Expectations
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>4. Which persona best describes you?</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            4.1- Software Engineer
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            4.2- Non-Technical User
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            4.3- Other (Please Specify)
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>5. What could we improve in this documentation?</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            5.1- (Open Text Response)
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>6. Would you recommend this documentation to a colleague?</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            6.1- Yes
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            6.2- No
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            6.3- Not sure
          </span>
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">5. FAQs</h2>
        <p style={{ textAlign: 'left', width: '100%' }}>
          <span style={{ paddingLeft: `0` }}>
            <b>1. How helpful did you find this documentation?</b>
          </span>
          <br />
          <br />
          <b>Answer:</b> An API (Application Programming Interface) allows your
          React application to communicate with a server to retrieve or send
          data. This is crucial for dynamic applications that need to display
          up-to-date information or interact with external services.
          <br />
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>
              2. How do I install the necessary tools to start working with APIs
              in React?
            </b>
          </span>
          <br />
          <br />
          <b>Answer:</b> You'll need Node.js and npm (Node Package Manager)
          installed on your machine. These tools help manage your React project.
          Once installed, you can use npx create-react-app to set up a new React
          project and npm install axios to install Axios, a library for making
          API requests.
          <br />
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>3. What are React Hooks, and how do they help with API calls?</b>
          </span>
          <br />
          <br />
          <b>Answer</b>: React Hooks, like <code>useState</code> and{' '}
          <code>useEffect</code>, are functions that allow you to use state and
          other React features without writing a class. useEffect is
          particularly useful for managing side effects, such as API requests,
          while useState helps manage data fetched from the API.
          <br />
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>
              4. How can I handle errors or loading states when fetching data
              from an API?
            </b>
          </span>
          <br />
          <br />
          <b>Answer</b>: You can manage these states by setting up boolean flags
          in your component state. For example, you might use{' '}
          <code>loading</code> to indicate whether data is still being fetched
          and error to capture any issues that arise during the API call. This
          allows you to provide users with appropriate feedback, such as loading
          spinners or error messages.
          <br />
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>
              5. Can I reuse the code for API calls across different components?
            </b>
          </span>
          <br />
          <br />
          <b>Answer</b>: Yes, you can create a custom hook to encapsulate your
          API call logic. This makes your code more modular and reusable across
          different components, promoting better code maintenance and
          scalability.
          <br />
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>
              6. What should I do if I encounter issues while following this
              guide?
            </b>
          </span>
          <br />
          <br />
          <b>Answer</b>: If you run into any problems, first double-check your
          setup against the instructions provided. If issues persist, consider
          looking up error messages online, checking React and Axios
          documentation, or reaching out to a developer community for support.
          Your feedback in the survey section is also valuable to help us
          improve the guide.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">6. Case study</h2>
        <p style={{ textAlign: 'left', width: '100%' }}>
          This case study explores the development of a scalable API for a
          FinTech application. The API is designed to manage financial
          transactions, user authentication, and real-time analytics for a
          rapidly growing user base. The study outlines the challenges faced,
          the technology stack used, the implementation process, and the
          outcomes achieved. To provide a holistic view, two personas are
          included: a technical persona and a non-technical persona,
          illustrating the collaboration between different roles in the project.
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Project Overview</b>
          </span>
          <br />
          The client, a growing FinTech startup, required an API to support
          their mobile and web applications. The API needed to handle user
          registration, authentication, transaction processing, and provide
          real-time data analytics. The primary goals were scalability,
          security, and performance, as the user base was expected to grow
          exponentially.
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Challenges</b>
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>1. Scalability:</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.1- The API had to support thousands of concurrent users and
            millions of transactions per day.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            1.2- The architecture needed to accommodate future growth without
            major overhauls.
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>2. Security:</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.1- Financial data required the highest levels of security,
            including encryption, secure authentication, and regular audits.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            2.2- Compliance with industry standards such as PCI-DSS was
            mandatory.
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>3. Performance:</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            3.1- The API had to ensure low-latency responses, especially for
            transaction processing.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            3.2- Real-time analytics needed to be provided with minimal delay.
          </span>
          <br />
          <span style={{ paddingLeft: `${pValue}px` }}>
            <b>4. Data Consistency and Integrity:</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            4.1- Handling transactions required maintaining consistency and
            integrity across distributed systems.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Collaboration Between Personas</b>
          </span>
          <br />
          <br />
          <b>Jamie Chen’s Role:</b>
          <br />
          Jamie was responsible for defining the API’s business requirements and
          ensuring that the technical solution aligned with the company’s
          strategic goals. She worked closely with stakeholders, including
          marketing, customer support, and the development team, to gather
          requirements and prioritize features.
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1- Stakeholder Communication:</b> Jamie facilitated communication
            between the development team and non-technical stakeholders,
            ensuring everyone understood the project’s goals and progress.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2- User-Centric Design:</b> He emphasized the importance of a
            user-friendly API that could easily be integrated by external
            developers, enhancing the overall user experience of the FinTech
            platform.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3- Feature Prioritisation:</b> Jamie used her market knowledge to
            prioritize features that would provide the most value to users and
            the business, such as real-time transaction processing and robust
            security measures.
          </span>
          <br />
          <br />
          <b>Alex Morgan’s Role:</b>
          <br />
          Alex Morgan led the technical implementation of the API. He translated
          the business requirements provided by Emily into a scalable and secure
          technical solution.
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1- Technical Design:</b> Alex designed the API architecture,
            focusing on scalability, security, and performance. He chose
            technologies and frameworks that would meet the project’s technical
            requirements.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2- Development and Testing:</b> He oversaw the development
            process, ensuring that the code met high standards of quality and
            security. Alex also implemented automated testing to catch issues
            early.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3- Technical Communication:</b> Alex regularly updated Emily on
            the technical progress, explaining complex concepts in a way that
            was understandable to non-technical stakeholders.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Technology Stack</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1- Programming Language:</b> React
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2- Framework:</b> Next.js (for rapid development and robust
            security features)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3- Database:</b> PostgreSQL (for its ACID compliance and
            scalability)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4- Caching:</b> Redis (to improve the speed of data retrieval)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5- Message Broker:</b> RabbitMQ (for handling asynchronous tasks
            and ensuring that transaction data is processed reliably)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>6- Cloud Provider:</b> AWS (for its scalability and comprehensive
            suite of services)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>7- Containerization:</b> Docker (to ensure consistent
            environments across development, testing, and production)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>8- Orchestration:</b> Kubernetes (to manage containerized
            applications in a clustered environment)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>9- Monitoring:</b> Prometheus and Grafana (for real-time
            monitoring and alerting)
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>10- Authentication:</b> OAuth 2.0 and JWT (for secure and
            scalable user authentication)
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Implementation Process</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1. API Design:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1.1- RESTful Architecture:</b> The API was designed using REST
            principles, ensuring statelessness, scalability, and simplicity.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1.2- Resource Modeling:</b> Each endpoint was carefully designed
            to represent a distinct resource (e.g., users, transactions,
            accounts).
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1.3- Versioning:</b> To ensure backward compatibility, the API
            was versioned from the outset, allowing future iterations without
            disrupting existing clients.
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2. Authentication and Security:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2.1- OAuth 2.0:</b> Implemented for secure user authentication,
            allowing third-party applications to access the API on behalf of the
            user.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2.2- JWT Tokens:</b> Used for session management, providing a
            stateless and scalable solution.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2.3- Encryption:</b> All sensitive data, including transaction
            details and user credentials, were encrypted using AES-256.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2.4- Rate Limiting:</b> Implemented to prevent abuse and ensure
            fair usage of API resources.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2.5- Audit Logs:</b> All actions were logged with detailed
            metadata to ensure traceability and facilitate compliance audits.
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3. Scalability:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3.1- Microservices Architecture:</b> The API was broken down into
            independent services (e.g., authentication, transaction processing,
            analytics), each deployed and scaled independently.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3.2- Auto-scaling:</b> AWS Auto Scaling was configured to
            automatically adjust the number of instances based on traffic and
            workload.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3.3- Load Balancing:</b> AWS Elastic Load Balancer (ELB) was used
            to distribute incoming traffic across multiple instances, ensuring
            high availability.
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4. Performance Optimization:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4.1- Caching Layer:</b> Redis was used to cache frequently
            accessed data, reducing the load on the database and decreasing
            response times.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4.2- Database Indexing:</b> PostgreSQL indexes were optimized for
            faster query performance, especially on large datasets.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4.2- Asynchronous Processing:</b> RabbitMQ was employed to handle
            background tasks like sending notifications or processing complex
            transactions, freeing up API resources for more immediate requests.
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5. Monitoring and Maintenance:</b>
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5.1- Real-Time Monitoring:</b> Prometheus was set up to collect
            and store metrics, while Grafana was used to visualize these metrics
            in real-time.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5.2- Alerting:</b> Alerts were configured for critical issues,
            such as high error rates or latency spikes, allowing the team to
            respond proactively.
          </span>
          <span
            style={{
              paddingLeft: `${pValue + pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5.3- Logging:</b> Centralized logging with AWS CloudWatch enabled
            the team to track and debug issues across the distributed system.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Outcomes</b>
          </span>
          <br />
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>1. Scalability:</b> The API successfully scaled to handle over
            10,000 concurrent users and processed millions of transactions daily
            without performance degradation.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>2. Security:</b> There were no security breaches, and the system
            passed all PCI-DSS compliance audits.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>3. Performance:</b> Average response time was kept under 200ms,
            even during peak usage periods, thanks to optimized caching and
            efficient database queries.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>4. Reliability:</b> With the microservices architecture and
            auto-scaling in place, the API maintained 99.99% uptime.
          </span>
          <span
            style={{
              paddingLeft: `${pValue}px`,
              marginTop: `${pValue - 10}px`,
              display: 'block'
            }}
          >
            <b>5. Client Satisfaction:</b> The client was highly satisfied with
            the API’s performance and scalability, allowing them to focus on
            user acquisition and product features without worrying about backend
            limitations.
          </span>
          <br />
          <br />
          <span style={{ paddingLeft: `0` }}>
            <b>Conclusion</b>
          </span>
          <br />
          This case study highlights the importance of collaboration between
          technical and non-technical roles in API development. The project’s
          success was driven by a well-thought-out architecture, modern tools
          and practices, and effective communication between the development
          team and stakeholders.
          <br />
          <br />
          <b>Technical Persona Reflection:</b> Alex Morgan's expertise in
          backend services and API development was crucial in delivering a
          robust and secure solution. His technical decisions were informed by
          the business requirements articulated by the product manager, ensuring
          that the API was both technically sound and aligned with business
          goals.
          <br />
          <br />
          <b>Non-Technical Persona Reflection:</b> Jamie Chen played a vital
          role in ensuring that the API met the needs of both users and the
          business. Her ability to communicate effectively with both technical
          and non-technical stakeholders ensured that the project stayed on
          track and delivered value to the company. Her focus on user experience
          and business alignment was instrumental in prioritizing features that
          drove user satisfaction and business growth.
        </p>
      </BailetsBlock>
    </>
  );
};
